export default __webpack_public_path__ + "static/media/login-background.573690fe.jpg";